module.exports = __webpack_public_path__ + "static/portfolio-mas-6-745072a89d6b21c82d245852fc40040a.jpg";